'use client'

import { useConsentManager } from '@c15t/nextjs'

/**
 * Consent hook for the Insider CDP (Customer Data Platform).
 *
 * Insider tracks user behaviour and falls under the `measurement` consent
 * category alongside GTM / GA.
 * Returns `enabled: true` only after the user grants measurement consent.
 */
export function useInsiderConsent() {
  const { has } = useConsentManager()

  return {
    /** Whether the Insider script may be loaded */
    enabled: has('measurement'),
  }
}
